import styled from 'styled-components';

const ConversationListStyled = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
`;

export { ConversationListStyled };
